import BaseInputsGrid from "@/components/reusables/BaseInputsGrid";
import { isSystemIntegratedSelector } from "@/redux/features/auth/authSlice";
import { useAppSelector } from "@/redux/hooks";
import { useTranslation } from "react-i18next";
import TwentyFourSevenOfficeProjectsDropdown from "./TwentyFourSevenOfficeProjectsDropdown";

export default function IntegrationsSection() {
    const { t } = useTranslation("", {
        keyPrefix: "sales.orders.integrations",
    });

    const isTwentyFourSevenOfficeEnabled = useAppSelector(
        isSystemIntegratedSelector("twenty_four_seven_office")
    );

    if (!isTwentyFourSevenOfficeEnabled) {
        return null;
    }

    return (
        <>
            <BaseInputsGrid title={t("header")} cols={3}>
                <TwentyFourSevenOfficeProjectsDropdown />
            </BaseInputsGrid>
        </>
    );
}
